import store from '@store'

export default () => {
  ;(async () => {
    await store.dispatch('FedLogOut')
    location.reload()
  })()
}
